module.exports = __webpack_public_path__ + "static/media/country_mx.46666db3.webp";